












import { Vue, Component } from 'vue-property-decorator'

@Component
export default class ActivityShareMask extends Vue {
  closeMask() {
    // @ts-ignore
    this.$el.parentNode.removeChild(this.$el)
  }
}
